module.exports = __webpack_public_path__ + "static/summon-undead-mtg_clb-57b94f2cbf1dea3890df864490231ba4.jpg";